module.exports = __webpack_public_path__ + "img/luxemburg-night.252ff9b1.png";